/** Lightweight E.164 helpers for UI validation (server still enforces). */

const E164 = /^\+[1-9]\d{7,14}$/

export function normalizePhoneInput(raw: string): string {
  const trimmed = raw.trim().replace(/[\s().-]/g, '')
  if (trimmed.startsWith('+')) return trimmed
  if (/^\d{10}$/.test(trimmed)) return `+1${trimmed}`
  if (/^1\d{10}$/.test(trimmed)) return `+${trimmed}`
  return trimmed
}

export function isValidE164(phone: string): boolean {
  return E164.test(phone)
}

export function formatPhoneHint(last4: string): string {
  return `•••-•••-${last4}`
}
